e4.lazyload = {
    settings: {
        debug: false,
        lazyClass: 'js-e-content-lazyload',
        preloadClass: 'e-content-lazyload-placeholder',
        loadingClass: 'fade',
        loadedClass: 'in',
        backgroundTags: [
            'div',
            'span'
        ],
        observerOptions: {
            rootMargin: '400px 320px'
        }
    },
    utils: {
        isHighDensity: ( function () {
            return ( ( window.matchMedia && ( window.matchMedia( 'only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)' ).matches || window.matchMedia( 'only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)' ).matches ) ) || ( window.devicePixelRatio && window.devicePixelRatio > 1.3 ) );
        }() ),
        isRetina: ( function () {
            return ( ( window.matchMedia && ( window.matchMedia( 'only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)' ).matches || window.matchMedia( 'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)' ).matches ) ) || ( window.devicePixelRatio && window.devicePixelRatio >= 2 ) ) && /(iPad|iPhone|iPod)/g.test( navigator.userAgent );
        }() ),
        isBackgroundTag: function ( domElmTag ) {
            return e4.lazyload.settings.backgroundTags.indexOf( domElmTag ) > -1;
        },
        getWindowWidthByDensity: function () {
            var intWindowWidth = window.innerWidth,
                returnWindowWidth = intWindowWidth;
            if ( e4.lazyload.utils.isRetina === true ) {
                returnWindowWidth = ( intWindowWidth * 2 );
            }
            else if ( e4.lazyload.utils.isHighDensity === true ) {
                returnWindowWidth = ( intWindowWidth * 1.3 );
            }
            return returnWindowWidth;
        },
        getClosestSrcSetSize: function ( objSrcsetSizes ) {
            var intWindowWidthByDensity = e4.lazyload.utils.getWindowWidthByDensity();
            return objSrcsetSizes.srcset.reduce( function ( objPreviousSize, objCurrentSize ) {
                return ( Math.abs( objCurrentSize.width - intWindowWidthByDensity ) < Math.abs( objPreviousSize.width - intWindowWidthByDensity ) ? objCurrentSize : objPreviousSize );
            } );
        },
        getBackgroundSrcSetSizes: function ( srcset ) {
            var arrSrcset = srcset.split( ',' ),
                objSrcset = {
                    srcset: []
                };
            for ( var i = 0; i < arrSrcset.length; i++ ) {
                objSrcset.srcset.push( {} );

                var arrSrcsetAttributes = arrSrcset[ i ].split( ' ' );
                for ( var j = 0; j < arrSrcsetAttributes.length; j++ ) {
                    var arrSizes = arrSrcsetAttributes[ j ],
                        objSrcsetItem = objSrcset.srcset[ i ],
                        intSizesIndex = arrSizes.length - 1;
                    if ( arrSizes[ intSizesIndex ] !== 'w' && arrSizes[ intSizesIndex ] !== 'x' ) {
                        objSrcsetItem.src = arrSizes;
                    }
                    else {
                        if ( arrSizes[ intSizesIndex ] === 'w' ) {
                            objSrcsetItem.width = parseInt( arrSizes.slice( 0, -1 ) );
                        }
                        else if ( arrSizes[ intSizesIndex ] === 'x' ) {
                            objSrcsetItem.retina = ( parseInt( arrSizes.slice( 0, -1 ) ) > 1 );
                        }
                    }
                }
            }
            return objSrcset;
        },
        getElements: function () {
            return jQuery( '.' + e4.lazyload.settings.lazyClass ).toArray();
        },
        debug: function ( arrMessage, type, color ) {
            arrMessage = arrMessage === null ? [] : arrMessage;
            if ( type === null || type === undefined ) {
                type = 'log';
            }
            if ( color === null || color === undefined ) {
                color = '';
            }
            if ( e4.lazyload.settings.debug ) {
                console[ type ]( '%c' + arrMessage.join( ' ' ), 'color: ' + color );
            }
        }
    },
    init: function () {
        var arrDomElementsToLazyload = e4.lazyload.utils.getElements();
        if ( arrDomElementsToLazyload.length > 0 ) {
            e4.lazyload.utils.debug( [
                'Lazyload initialized'
            ], 'group' );
            e4.lazyload.utils.debug( [
                'Watching',
                arrDomElementsToLazyload.length,
                'lazyload elements width offset of',
                e4.lazyload.settings.observerOptions.rootMargin.split( ' ' )[ 0 ]
            ], 'log', 'orange' );
            e4.lazyload.utils.debug( [
                'Is high density:',
                e4.lazyload.utils.isHighDensity
            ], 'log', 'blue' );
            e4.lazyload.utils.debug( [
                'Is retina:',
                e4.lazyload.utils.isRetina
            ], 'log', 'blue' );
            e4.lazyload.utils.debug( null, 'groupEnd' );
            e4.util.observer.bind( arrDomElementsToLazyload, e4.lazyload.onElementIntersection, e4.lazyload.settings.observerOptions );
            //e4.lazyload.bindCarousels();

        }
    },
    bindCarousels: function () {
        jQuery( '.bramidan-carousel' ).on( 'slide.bs.carousel', function (event) {
            console.log('arguments');
            console.log(event.relatedTarget, event.relatedTarget.dataset.src, event.relatedTarget.dataset.srcset);
            
            e4.lazyload.setImageBackgroundSrc(event.relatedTarget, event.relatedTarget.dataset.src, event.relatedTarget.dataset.srcset);

        } )
    },
    onElementIntersection: function ( domElm, observer ) {
        if ( domElm.isIntersecting === true ) {
            var domElmTarget = domElm.target,
                domElmTag = domElmTarget.tagName.toLowerCase(),
                strDataSrc = jQuery( domElmTarget ).data( 'src' ),
                strDataSrcset = jQuery( domElmTarget ).data( 'srcset' );
            e4.lazyload.utils.debug( [
                'Intersecting',
                domElmTag,
                'element'
            ], 'log', 'blue' );
            if ( domElmTag === 'img' ) {
                e4.lazyload.setImageSrc( domElmTarget, strDataSrc, strDataSrcset );
            }
            else if ( e4.lazyload.utils.isBackgroundTag( domElmTag ) === true ) {
                e4.lazyload.setImageBackgroundSrc( domElmTarget, strDataSrc, strDataSrcset );
            }
            else if ( domElmTag === 'video' ) {
                e4.lazyload.setVideoSrc( domElmTarget );
            }
            else if ( domElmTag === 'iframe' ) {
                e4.lazyload.setIframeSrc( domElmTarget, strDataSrc );
            }
            else {
                e4.lazyload.utils.debug( [
                    'Not a valid lazyload tag:',
                    domElmTag
                ], 'warn' );
            }
            observer.unobserve( domElmTarget );
        }
    },
    setImageSrc: function ( domElmTarget, strDataSrc, strDataSrcset ) {
        e4.lazyload.loadTarget( domElmTarget, e4.lazyload.showLoadedTarget );
        if ( strDataSrcset !== undefined ) {
            jQuery( domElmTarget ).attr( 'srcset', strDataSrcset );
        }
        else {
            jQuery( domElmTarget ).attr( 'src', strDataSrc );
        }
    },
    setImageBackgroundSrc: function ( domElmTarget, strDataSrc, strDataSrcset ) {
        if ( strDataSrcset !== undefined ) {
            var objSrcsetSizes = e4.lazyload.utils.getBackgroundSrcSetSizes( strDataSrcset ),
                objClosestSrcsetSize = e4.lazyload.utils.getClosestSrcSetSize( objSrcsetSizes ),
                strSrcFromSrcSet = objClosestSrcsetSize.src;
            if ( strSrcFromSrcSet !== undefined ) {
                jQuery( domElmTarget ).css( 'background-image', 'url(' + strSrcFromSrcSet + ')' );
            }
        }
        else {
            jQuery( domElmTarget ).css( 'background-image', 'url(' + strDataSrc + ')' );
        }
        e4.lazyload.showLoadedTarget( domElmTarget );
    },
    setVideoSrc: function ( domElmTarget ) {
        domElmTarget.load();
        e4.lazyload.showLoadedTarget( domElmTarget );
    },
    setIframeSrc: function ( domElmTarget, strDataSrc ) {
        e4.lazyload.loadTarget( domElmTarget, e4.lazyload.showLoadedTarget );
        jQuery( domElmTarget ).attr( 'src', strDataSrc );
    },
    loadTarget: function ( domElmTarget, fnCallback ) {
        jQuery( domElmTarget ).one( 'load', function () {
            e4.lazyload.utils.debug( [
                'Loaded',
                domElmTarget.tagName.toLowerCase()
            ], 'log', 'blue' );
            if ( typeof fnCallback === 'function' ) {
                fnCallback( domElmTarget );
            }
        } );
    },
    showLoadedTarget: function ( domElmTarget ) {
        e4.lazyload.utils.debug( [ 'Lazyload target complete' ], 'group' );
        e4.lazyload.utils.debug( [
            'Showing',
            domElmTarget.tagName.toLowerCase(),
            'with current src',
            domElmTarget.currentSrc || domElmTarget.src || domElmTarget.style.backgroundImage
        ], 'log', 'blue' );
        if ( e4.lazyload.settings.loadedClass !== '' && domElmTarget.classList.contains( e4.lazyload.settings.loadingClass ) === true ) {
            jQuery( domElmTarget ).addClass( e4.lazyload.settings.loadedClass );
        }
        jQuery( domElmTarget ).removeClass( [
            e4.lazyload.settings.preloadClass,
            e4.lazyload.settings.lazyClass
        ].join( ' ' ) );
        var intTargetsRemaining = e4.lazyload.utils.getElements().length;
        if ( intTargetsRemaining > 0 ) {
            e4.lazyload.utils.debug( [
                intTargetsRemaining,
                'targets remaining'
            ], 'log', 'orange' );
        }
        else {
            e4.lazyload.utils.debug( [
                'Lazyload complete...'
            ], 'log', 'green' );
        }
        e4.lazyload.utils.debug( null, 'groupEnd' );
    }
};
